/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PlanDTO { 
    /**
     * Unique plan identifier. Use this value when fetching, updating, duplicating, or exporting a plan.
     */
    id: number;
    /**
     * Display title of the MPO plan shown in the plan list and plan detail pages.
     */
    title: string;
    /**
     * Optimization view for this plan.
     */
    viewType: PlanDTO.ViewTypeEnum;
    /**
     * True when this plan is the user\'s or client\'s default MPO plan.
     */
    isDefault: boolean;
    /**
     * True when the plan should be shown to the current user in the plan list.
     */
    isVisible: boolean;
    /**
     * True when the plan is shared across the brand rather than owned only by one user.
     */
    isShared: boolean;
    /**
     * Reference period start date for the plan, in ISO date format.
     */
    startDate: string;
    /**
     * Reference period end date for the plan, in ISO date format.
     */
    endDate: string;
    /**
     * Optional optimization period start date for the plan, in ISO date format.
     */
    planStartDate?: string;
    /**
     * Optional optimization period end date for the plan, in ISO date format.
     */
    planEndDate?: string;
    /**
     * Reference-period label used by the plan, e.g. \'Latest 30 Days\', \'Custom\'.
     */
    relativeDay: string;
    /**
     * Conversion type ID associated with the plan.
     */
    conversionTypeId: number;
    /**
     * Number of days optimized for this plan.
     */
    optimizedForDays: number;
    /**
     * Optimization level used by MPO. Use 2 for Balanced or 5 for Maximized.
     */
    optimizationLevel: number;
    /**
     * Table breakdown dimension used by the plan, such as tactic, channel, or segment.
     */
    tableDimension: PlanDTO.TableDimensionEnum;
    /**
     * Target budget for the plan in the brand\'s configured currency.
     */
    targetBudget: number;
    /**
     * User identifier for the plan owner, when available.
     */
    userId?: string;
    /**
     * Last modification timestamp for the plan in ISO-8601 format, when available.
     */
    rModTime?: string;
    /**
     * Current access level for the authenticated user against this plan.
     */
    permission: PlanDTO.PermissionEnum;
}
export namespace PlanDTO {
    export type ViewTypeEnum = 'ROAS' | 'CPO';
    export const ViewTypeEnum = {
        Roas: 'ROAS' as ViewTypeEnum,
        Cpo: 'CPO' as ViewTypeEnum
    };
    export type TableDimensionEnum = 'channel' | 'segment' | 'tactic' | 'conversionType';
    export const TableDimensionEnum = {
        Channel: 'channel' as TableDimensionEnum,
        Segment: 'segment' as TableDimensionEnum,
        Tactic: 'tactic' as TableDimensionEnum,
        ConversionType: 'conversionType' as TableDimensionEnum
    };
    export type PermissionEnum = 'OWNER' | 'READ' | 'WRITE';
    export const PermissionEnum = {
        Owner: 'OWNER' as PermissionEnum,
        Read: 'READ' as PermissionEnum,
        Write: 'WRITE' as PermissionEnum
    };
}


